import { jsxs as d, jsx as K } from "react/jsx-runtime";
import { forwardRef as w, useMemo as r, cloneElement as f } from "react";
import { c as n } from "./tw-cn-mXgPecoF.mjs";
import { e as E } from "./extract-responsive-property-BiJ5BiwI.mjs";
import { D as M } from "./dot-badge-r5y1_6Q8.mjs";
import { r as _, a as k } from "./rectangle-button.styles-BE1aDLeU.mjs";
const q = w(
  ({
    theme: u = "filled_primary",
    disabled: g = !1,
    fullWidth: S = !1,
    isCapsule: b = !1,
    showDotBadge: c = !1,
    loading: i = !1,
    size: y,
    weight: z = "bold",
    direction: a = "left",
    disabledType: N = "default",
    ...v
  }, x) => {
    const { children: h, type: R = "button", icon: e, iconVisualCorrectionSpacing: s, className: I, ...P } = v, t = E({
      property: y,
      mobileKey: "size",
      pcKey: "pcSize",
      defaultValue: { mobile: "medium", pc: "large" }
    }), V = _({ fullWidth: S, ...t, theme: u, weight: z, isCapsule: b, disabledType: N }), l = k({ ...t, direction: a }), o = g || i, $ = r(() => e && a === "left" ? f(e, { className: n(l, e.props.className) }) : null, [e, a, l]), B = r(() => e && a === "right" ? f(e, { className: n(l, e.props.className) }) : null, [e, a, l]), C = r(() => {
      if (!s) return;
      const D = t.size === "small" ? 8 : 16, p = s + D, j = t.pcSize === "small" ? 8 : 16, m = s + j;
      return a === "left" ? `pr-${p} pc:pr-${m}` : `pl-${p} pc:pl-${m}`;
    }, [a, s, t.size, t.pcSize]);
    return /* @__PURE__ */ d(
      "button",
      {
        "aria-disabled": o || void 0,
        className: n(V, C, I),
        "data-state": i ? "loading" : void 0,
        disabled: o,
        ref: x,
        tabIndex: o ? -1 : 0,
        type: R,
        ...P,
        children: [
          $,
          /* @__PURE__ */ d("span", { className: n("relative flex", !c && "overflow-hidden"), children: [
            h,
            !!c && !o && /* @__PURE__ */ K(M, {})
          ] }),
          B
        ]
      }
    );
  }
);
q.displayName = "NDS.RectangleButton";
export {
  q as R
};
